import axios from "../api/axios";
import {COUPON_VALIDATE_URL_1, COUPON_VALIDATE_URL_2} from "../utils/constants";

export async function couponValidate(data: any, couponCode: string): Promise<any> {
    const response = await axios.post(`${COUPON_VALIDATE_URL_1}${couponCode}${COUPON_VALIDATE_URL_2}`, data);
    return response.data;
}
